/** Vente validée = facture normalisée EMCeF confirmée (sans erreur). */
export const isBrokenTileSaleValidated = (sale) => {
  if (sale?.is_validated === true) return true;
  if (sale?.is_validated === false) return false;

  const raw = sale?.emecef_data;
  if (raw == null || raw === '') return false;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed || trimmed === 'null') return false;
    try {
      const parsed = JSON.parse(trimmed);
      return Boolean(parsed && !parsed.error && (parsed.codeMECeFDGI || parsed.uid));
    } catch {
      return true;
    }
  }
  return Boolean(raw && !raw.error && (raw.codeMECeFDGI || raw.uid));
};

/** Montant net encaissé (après remise), hors analyse FIFO. */
export const getSaleNetRevenue = (sale) => {
  const net = parseFloat(sale?.montant_net);
  if (!Number.isNaN(net) && net > 0) return net;
  const total = parseFloat(sale?.total_amount) || 0;
  const discount = parseFloat(sale?.discount) || 0;
  return Math.max(0, total - discount);
};

export const TOOLTIP_ENCAISSEMENTS =
  "Somme des montants nets encaissés sur les ventes affichées (après remise). C'est l'argent rentré en caisse, sans tenir compte du coût FIFO ni des pertes.";

export const TOOLTIP_COST_FIFO_PERIOD =
  "Coût de revient des m² vendus sur la période, en FIFO : on consomme d'abord les entrées « carreaux cassés » les plus anciennes ; chaque m² vendu emporte le prix de revient du lot correspondant (snapshot à l'enregistrement du cassage).";

export const TOOLTIP_COST_FIFO_SALE =
  "Pour cette vente : chaque ligne (sacs × format en m²) retire du stock FIFO ; coût = somme des (m² pris sur chaque lot × prix de revient au m² du lot).";

export const TOOLTIP_M2_FIFO =
  "m² de la vente répartis sur les carreaux cassés selon l'ordre FIFO (estimation : le sac vendu n'identifie pas la variante).";

export const TOOLTIP_LOSS =
  "Perte = coût FIFO − montant net encaissé. Montant positif = vente en dessous du coût de revient ; négatif = marge.";

export const TOOLTIP_LOSS_PERIOD =
  "Perte nette période = coût revient vendu (FIFO) − encaissements nets. Positif = perte globale sur la période.";

export const lineTotalForBrokenTileItem = (item) => {
  if (item?.total_price != null && Number(item.total_price) > 0) {
    return Number(item.total_price);
  }
  const m2 = item?.m2 ?? (Number(item?.quantity || 0) * Number(item?.format || item?.bag_size || 0));
  return Number(item?.unit_price || 0) * Number(m2 || 0);
};
